import React, { useEffect, useState } from 'react';
import { NETWORK_ERROR_MESSAGE } from '../../utils/apiError';
import './OfflineBanner.css';

/**
 * Persistent banner while the browser reports offline.
 * Complements the debounced toast from the Axios interceptor.
 */
const OfflineBanner = () => {
  const [isOffline, setIsOffline] = useState(
    typeof navigator !== 'undefined' ? !navigator.onLine : false
  );

  useEffect(() => {
    const goOffline = () => setIsOffline(true);
    const goOnline = () => setIsOffline(false);

    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);

    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, []);

  if (!isOffline) return null;

  return (
    <div className="offline-banner" role="status" aria-live="polite">
      {NETWORK_ERROR_MESSAGE}
    </div>
  );
};

export default OfflineBanner;
